// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { Popup } from '@progress/kendo-vue-popup';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * Represents the default `ListContainer` component.
 */

var ListContainer = {
  name: 'list-container',
  props: {
    width: [String, Number],
    dir: String,
    itemsCount: Number,
    popupSettings: {
      type: Object,
      default: function _default() {
        return {
          animate: true,
          height: '200px'
        };
      }
    }
  },
  created: function created() {
    this.kendoAnchorRef = undefined;
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  methods: {
    onMouseDown: function onMouseDown(e) {
      this.$emit('mousedown', e);
    },
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    },
    onOpen: function onOpen(e) {
      this.$emit('open', e);
    },
    onClose: function onClose(e) {
      this.$emit('close', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    var _a = this.$props,
        onMouseDown = _a.onMouseDown,
        onBlur = _a.onBlur,
        width = _a.width,
        dir = _a.dir,
        popupSettings = _a.popupSettings; // @ts-ignore

    var className = popupSettings.className,
        animate = popupSettings.animate,
        anchor = popupSettings.anchor,
        show = popupSettings.show,
        open = popupSettings.open,
        close = popupSettings.close,
        itemsCount = popupSettings.itemsCount;
    return (// @ts-ignore function children
      h(Popup, {
        style: {
          width: width,
          direction: dir
        },
        className: className,
        attrs: this.v3 ? undefined : {
          className: className,
          animate: animate,
          anchor: anchor,
          show: show,
          contentKey: itemsCount
        },
        animate: animate,
        anchor: anchor,
        show: show,
        contentKey: itemsCount,
        onOpen: this.onOpen,
        on: this.v3 ? undefined : {
          "open": this.onOpen,
          "close": this.onClose
        },
        onClose: this.onClose
      }, this.v3 ? function () {
        return [h("div", {
          onMousedown: _this.onMouseDown,
          on: _this.v3 ? undefined : {
            "mousedown": _this.onMouseDown,
            "focusout": _this.onBlur
          },
          onFocusout: _this.onBlur
        }, [defaultSlot])];
      } : [h("div", {
        onMousedown: _this.onMouseDown,
        on: _this.v3 ? undefined : {
          "mousedown": _this.onMouseDown,
          "focusout": _this.onBlur
        },
        onFocusout: _this.onBlur
      }, [defaultSlot])])
    );
  }
};
export { ListContainer };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dropdowns/dist/es/common/ListContainer.js
// module id = 153
// module chunks = 93